<template>
  <div>
    <HeaderReceipt header="เพิ่มสินค้าเข้าคลังด้วยใบสั่งซื้อ" :img_header="header_image" link_back="stock/storage/addproducttostock"/>
    <StoragePO/>
  </div>
</template>

<script>
import HeaderImage from '@/assets/completed-task.png'
import HeaderReceipt from "@/components/admin/stock/menustorage/HeaderReceipt.vue";
import StoragePO from "@/components/admin/stock/po/StoragePO.vue";
export default {
  name: "PoReceipt",
  components: {
    StoragePO,
    HeaderReceipt
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>
